import { Flex, Spacer, Text } from '@chakra-ui/react';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { CompaniesPieColors } from 'slices/modules/companies/companiesPieColors';
import AnalyticsCompaniesPie from './AnalyticsCompaniesPie';
import PieChartCompanyList from 'presentation/components/shared/chart/pieChart/PieChartCompanyList';

interface Props {
  companies: PortfolioAnalyticsCompanyListItem[];
  pieColors: CompaniesPieColors;
}

const AnalyticsCompaniesLoaded: FC<Props> = ({ companies, pieColors }) => {
  const { t } = useTranslation();

  if (companies.length === 0) {
    return <Text textAlign="center">{t('listIsEmpty')}</Text>;
  }

  return (
    <Flex w="100%">
      <AnalyticsCompaniesPie companies={companies} pieColors={pieColors} />
      <Spacer maxW="40px" w="40px" />
      <PieChartCompanyList items={companies} pieColors={pieColors} />
    </Flex>
  );
};

export default AnalyticsCompaniesLoaded;
